import { useState, useEffect } from "react";
import { getCrmKisiler, addCrmKisi, updateCrmKisi, deleteCrmKisi, getCrmFirmalar } from "../services/api";

const EMPTY_FORM = { firma_id: "", ad_soyad: "", pozisyon: "", telefon: "", email: "", notlar: "" };

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const th   = { padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "var(--text-muted)", borderBottom: "1px solid var(--border-hairline)", textTransform: "uppercase", letterSpacing: ".05em" };
const td   = { padding: "11px 14px", fontSize: 13, color: "var(--text-primary)", borderBottom: "1px solid var(--border-hairline)" };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

export default function CrmKisiler() {
  const [kisiler, setKisiler] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [firmaFiltre, setFirmaFiltre] = useState("");
  const [msg, setMsg] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    getCrmFirmalar().then((r) => setFirmalar(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [firmaFiltre]);

  async function load() {
    setLoading(true);
    try {
      setKisiler((await getCrmKisiler({ firma_id: firmaFiltre || undefined, search })).data);
    } catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const payload = { ...form, firma_id: form.firma_id || null };
    try {
      if (editId) {
        await updateCrmKisi(editId, payload);
        flash("Kisi guncellendi");
      } else {
        await addCrmKisi(payload);
        flash("Kisi eklendi");
      }
      setForm(EMPTY_FORM);
      setEditId(null);
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  function handleEdit(k) {
    setEditId(k.ID);
    setForm({
      firma_id: k.FirmaID || "", ad_soyad: k.AdSoyad || "", pozisyon: k.Pozisyon || "",
      telefon: k.Telefon || "", email: k.Email || "", notlar: k.Notlar || "",
    });
  }

  function handleCancelEdit() {
    setEditId(null);
    setForm(EMPTY_FORM);
  }

  async function handleDelete(id, adSoyad) {
    if (!window.confirm(`"${adSoyad}" silinsin mi?`)) return;
    try {
      await deleteCrmKisi(id);
      flash("Silindi");
      load();
    } catch { flash("Silinemedi", "error"); }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 16 }}>
          {editId ? "Kisi Duzenle" : "Yeni Kisi Ekle"}
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>FIRMA</div>
              <select style={inp} value={form.firma_id} onChange={(e) => setForm({ ...form, firma_id: e.target.value })}>
                <option value="">Firma yok</option>
                {firmalar.map((f) => (
                  <option key={f.CARI_KOD} value={f.CARI_KOD}>{f.Unvan}</option>
                ))}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>AD SOYAD</div>
              <input style={inp} value={form.ad_soyad} required
                onChange={(e) => setForm({ ...form, ad_soyad: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>POZISYON</div>
              <input style={inp} value={form.pozisyon}
                onChange={(e) => setForm({ ...form, pozisyon: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TELEFON</div>
              <input style={inp} value={form.telefon}
                onChange={(e) => setForm({ ...form, telefon: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>EMAIL</div>
              <input style={inp} type="email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>NOTLAR</div>
              <input style={inp} value={form.notlar}
                onChange={(e) => setForm({ ...form, notlar: e.target.value })} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button type="submit" style={btn("var(--accent)", "#fff")}>{editId ? "Guncelle" : "Kisi Ekle"}</button>
            {editId && (
              <button type="button" onClick={handleCancelEdit} style={btn("var(--border)", "var(--text-secondary)")}>Iptal</button>
            )}
          </div>
        </form>
      </div>

      <div style={{ ...card, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <input
          style={{ ...inp, maxWidth: 260 }}
          placeholder="Ad soyada gore ara..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
        />
        <select style={{ ...inp, maxWidth: 240 }} value={firmaFiltre} onChange={(e) => setFirmaFiltre(e.target.value)}>
          <option value="">Tum firmalar</option>
          {firmalar.map((f) => (
            <option key={f.CARI_KOD} value={f.CARI_KOD}>{f.Unvan}</option>
          ))}
        </select>
        <button onClick={load} style={btn("var(--accent-bg)", "var(--accent-text)")}>Ara</button>
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--bg-sidebar)" }}>
              {["Ad Soyad", "Firma", "Pozisyon", "Telefon", "Email", ""].map((h) => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
            {!loading && kisiler.length === 0 && <tr><td colSpan={6} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Henuz kisi eklenmemis.</td></tr>}
            {kisiler.map((k) => (
              <tr key={k.ID}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-card-alt)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 600 }}>{k.AdSoyad}</td>
                <td style={td}>{k.FirmaUnvani || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{k.Pozisyon || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{k.Telefon || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{k.Email || "-"}</td>
                <td style={{ ...td, display: "flex", gap: 6 }}>
                  <button onClick={() => handleEdit(k)}
                    style={{ background: "var(--accent-bg)", color: "var(--accent-text)", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    Duzenle
                  </button>
                  <button onClick={() => handleDelete(k.ID, k.AdSoyad)}
                    style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
